module.exports = false;


//////////////////
// WEBPACK FOOTER
// /var/lib/jenkins/workspace/venyou-stripe/~/core-js/modules/_library.js
// module id = ../../../../core-js/modules/_library.js
// module chunks = 1